const METER_IMPORT_HEADERS = [
	"serial_number",
	"encryption_key",
	"type",
	"street",
	"apartment_number",
] as const;

export type MeterImportParsedRow = {
	serial_number: string;
	encryption_key: string;
	type: string;
	street: string;
	apartment_number: string;
};

export type MeterImportParseResult =
	| { ok: true; rows: MeterImportParsedRow[] }
	| { ok: false; error: string };

function splitLine(line: string): string[] {
	return line.split(";").map((c) => c.trim());
}

export function parseMeterImportCsv(text: string): MeterImportParseResult {
	const cleaned = text.replace(/^\uFEFF/, "");
	if (cleaned.includes("\uFFFD")) return { ok: false, error: "encoding" };
	const lines = cleaned
		.split(/\r?\n/)
		.map((l) => l.trim())
		.filter((l) => l.length > 0);
	if (lines.length === 0) return { ok: false, error: "empty" };

	const headerCells = splitLine(lines[0]).map((h) => h.toLowerCase());
	const required = ["serial_number", "type"];
	for (const r of required) {
		if (!headerCells.includes(r)) return { ok: false, error: "missing_header" };
	}
	const idxs = METER_IMPORT_HEADERS.map((h) => headerCells.indexOf(h));

	const rows: MeterImportParsedRow[] = [];
	for (let i = 1; i < lines.length; i++) {
		const cells = splitLine(lines[i]);
		rows.push({
			serial_number: idxs[0] >= 0 ? (cells[idxs[0]] ?? "") : "",
			encryption_key: idxs[1] >= 0 ? (cells[idxs[1]] ?? "") : "",
			type: idxs[2] >= 0 ? (cells[idxs[2]] ?? "") : "",
			street: idxs[3] >= 0 ? (cells[idxs[3]] ?? "") : "",
			apartment_number: idxs[4] >= 0 ? (cells[idxs[4]] ?? "") : "",
		});
	}
	return { ok: true, rows };
}

export function buildMeterImportCsv(rows: MeterImportParsedRow[]): string {
	const header = METER_IMPORT_HEADERS.join(";");
	const body = rows
		.map((r) =>
			[
				r.serial_number,
				r.encryption_key,
				r.type,
				r.street,
				r.apartment_number,
			].join(";"),
		)
		.join("\n");
	return `${header}\n${body}\n`;
}
